module.exports = __webpack_public_path__ + "static/media/sports_14.590e385b.jpg";